import { Component, OnInit } from '@angular/core'
import { Router, ActivatedRoute } from '@angular/router';
import { ApiClient } from '../common/api-client.service';

interface Txn {
  fund_id: number;
  account_id: number
  amount: string;
  tags: string;
}

interface Sheet {
  id: number;
  name: string;
  transactions: Txn[];
}

@Component({
  templateUrl: './edit.component.html'
})
export class EditSheetComponent implements OnInit {
  funds: Array<any> = [];
  accounts: Array<any> = [];
  sheet: Sheet = {id: null, name: null, transactions: []};

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private apiClient: ApiClient,
  ) {}

  ngOnInit() {
    this.apiClient.get<any>('/api/v1/ledger/details').toPromise().then(ledger => {
      this.funds = ledger.funds;
      this.accounts = ledger.accounts;
    });

    this.route.params.subscribe(params => {
      this.sheet.id = params['id'];
      if ( this.sheet.id ) {
        this.apiClient.get<Sheet>(`/api/v1/sheets/${this.sheet.id}`).toPromise().then(s => this.sheet = s);
      } else {
        this.add();
      }
    })
  }

  total(): number {
    return this.sheet.transactions.reduce((a, txn) => {
      return txn.amount && txn.amount !== '-' ? a + parseFloat(txn.amount) : a;
     }, 0);
  }

  add(): void {
    this.sheet.transactions.push({fund_id: null, account_id: null, amount: null, tags: null});
  }

  remove(txn: Txn): void {
    this.sheet.transactions.splice(this.sheet.transactions.indexOf(txn), 1);
  }

  save(): void {
    const data = {
      name: this.sheet.name,
      transactions: this.sheet.transactions.filter(t => t.account_id || t.fund_id || t.amount)
    };

    const save = this.sheet.id ?
      this.apiClient.patch<Sheet>(`/api/v1/sheets/${this.sheet.id}`, data) :
      this.apiClient.post<Sheet>('/api/v1/sheets', data)

    save.toPromise().then(() => {
      // TODO success
      this.router.navigateByUrl('/sheets')
    }, resp => {
      // TODO error
      alert(resp.error.errors);
    })
  }
}



// WEBPACK FOOTER //
// /srv/src/app/sheets/edit.component.ts